var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNftDevelopment = function SvgNftDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 532 462"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8BAC9",
    d: "m430.245 345.565-80.119 46.267L270 345.565l80.126-46.261z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__a)",
    d: "m430.245 316.379-80.119 46.26L270 316.379l80.126-46.261z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__b)",
    d: "M350.126 362.639v22.516L270 338.895v-22.516z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__c)",
    d: "M350.126 362.639v22.516L270 338.895v-22.516z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__d)",
    d: "M430.244 316.379v22.516l-80.119 46.26v-22.516z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__e)",
    d: "M430.244 316.379v22.516l-80.119 46.26v-22.516z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__f)",
    d: "M430.244 316.379v22.516l-80.119 46.26v-22.516z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.35,
    d: "m430.245 316.379-80.119 46.26L270 316.379l80.126-46.261z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__g)",
    d: "m430.245 294.261-80.119 46.261L270 294.261 350.126 248z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__h)",
    d: "m430.245 294.261-80.119 46.261L270 294.261 350.126 248z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__i)",
    d: "m410.179 294.261-60.061 34.675-60.054-34.675 60.061-34.675z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__j)",
    d: "m410.179 294.261-60.061 34.675-60.054-34.675 60.061-34.675z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__k)",
    d: "M350.126 340.522v6.636L270 300.898v-6.637z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__l)",
    d: "M350.126 340.522v6.636L270 300.898v-6.637z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__m)",
    d: "M430.244 294.261v6.637l-80.119 46.26v-6.636z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__n)",
    d: "M430.244 294.261v6.637l-80.119 46.26v-6.636z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.999 268.662a.525.525 0 0 0-.001-.908l-4.185-2.419a.523.523 0 1 0-.525.908l4.185 2.42a.53.53 0 0 0 .526-.001m27.295-12.613a.525.525 0 0 0-.525-.909l-4.185 2.419a.525.525 0 1 0 .525.909zm-34.364 16.698a.525.525 0 0 0-.001-.909l-4.185-2.419a.525.525 0 1 0-.525.909l4.185 2.419a.53.53 0 0 0 .526 0m-3.531 2.039a.525.525 0 0 0-.001-.909l-4.185-2.419a.525.525 0 1 0-.525.909l4.185 2.419a.53.53 0 0 0 .526 0m24.73-14.28a.525.525 0 0 0 0-.908l-4.185-2.419a.526.526 0 1 0-.525.909l4.184 2.419a.52.52 0 0 0 .526-.001M287.6 295.379a.53.53 0 0 0-.526-.001l-4.185 2.419a.525.525 0 0 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m45.93-28.756a.525.525 0 0 0-.001-.908l-4.185-2.419a.526.526 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527-.001m-17.662 10.201a.525.525 0 0 0-.001-.908l-4.185-2.419a.525.525 0 1 0-.525.909l4.185 2.419a.52.52 0 0 0 .526-.001m21.193-12.24a.525.525 0 0 0-.001-.908l-4.185-2.419a.526.526 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527-.001m-10.593 6.117a.525.525 0 0 0-.001-.908l-4.185-2.419a.523.523 0 1 0-.525.908l4.185 2.419a.52.52 0 0 0 .526 0m-35.33 20.403a.526.526 0 0 0-.001-.909l-4.185-2.419a.524.524 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527 0m3.531-2.039a.526.526 0 0 0-.001-.909l-4.185-2.419a.524.524 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527 0m-7.062 4.078a.526.526 0 0 0-.001-.909l-4.185-2.419a.524.524 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527 0m10.593-6.124a.525.525 0 0 0-.001-.908l-4.185-2.419a.526.526 0 1 0-.525.909l4.184 2.419a.53.53 0 0 0 .527-.001m3.537-2.039a.524.524 0 0 0-.001-.908l-4.184-2.419a.526.526 0 0 0-.526.909l4.185 2.419a.52.52 0 0 0 .526-.001m7.062-4.078a.524.524 0 0 0-.001-.908l-4.184-2.419a.526.526 0 0 0-.526.909l4.185 2.419a.52.52 0 0 0 .526-.001m-3.531 2.039a.524.524 0 0 0-.001-.908l-4.184-2.419a.526.526 0 0 0-.526.909l4.185 2.419a.52.52 0 0 0 .526-.001m7.069-4.078a.525.525 0 0 0-.001-.908l-4.185-2.419a.525.525 0 1 0-.525.909l4.185 2.419a.52.52 0 0 0 .526-.001m28.261-16.318a.525.525 0 0 0 0-.908l-4.185-2.419a.526.526 0 1 0-.525.909l4.184 2.419a.52.52 0 0 0 .526-.001m54.384 20.396a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.526-.909l-4.184 2.419a.525.525 0 0 0-.001.908m3.531 2.039a.52.52 0 0 0 .526.001l4.185-2.419a.526.526 0 0 0-.526-.909l-4.184 2.419a.524.524 0 0 0-.001.908m3.531 2.039a.52.52 0 0 0 .526.001l4.185-2.419a.526.526 0 0 0-.526-.909l-4.184 2.419a.525.525 0 0 0-.001.908m-10.6-6.117a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.525-.909l-4.185 2.419a.525.525 0 0 0-.001.908m17.669 10.195a.52.52 0 0 0 .526 0l4.185-2.419a.525.525 0 1 0-.526-.908l-4.185 2.419a.525.525 0 0 0 0 .908m3.531 2.039a.52.52 0 0 0 .526 0l4.185-2.419a.525.525 0 1 0-.526-.908l-4.185 2.419a.525.525 0 0 0 0 .908m-24.731-14.273a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 1 0-.525-.909l-4.185 2.419a.525.525 0 0 0-.001.908m17.662 10.195a.53.53 0 0 0 .526.001l4.185-2.419a.526.526 0 0 0-.526-.909l-4.184 2.419a.525.525 0 0 0-.001.908m-24.731-14.279a.53.53 0 0 0 .527 0l4.184-2.419a.524.524 0 1 0-.525-.909l-4.185 2.419a.526.526 0 0 0-.001.909m-17.661-10.195a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.526-.909l-4.184 2.419a.524.524 0 0 0-.001.908m3.531 2.039a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.526-.909l-4.184 2.419a.524.524 0 0 0-.001.908m-7.062-4.078a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.526-.909l-4.184 2.419a.524.524 0 0 0-.001.908m10.599 6.117a.53.53 0 0 0 .527.001l4.184-2.42a.524.524 0 1 0-.525-.908l-4.185 2.419a.525.525 0 0 0-.001.908m3.531 2.039a.53.53 0 0 0 .527 0l4.184-2.419a.524.524 0 1 0-.525-.908l-4.185 2.419a.525.525 0 0 0-.001.908m-17.668-10.195a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 0 0-.526-.909l-4.184 2.419a.525.525 0 0 0-.001.908m28.268 16.318a.52.52 0 0 0 .526.001l4.185-2.419a.525.525 0 1 0-.525-.909l-4.185 2.419a.525.525 0 0 0-.001.908m-7.069-4.084a.53.53 0 0 0 .527 0l4.184-2.419a.524.524 0 1 0-.525-.909l-4.185 2.42a.525.525 0 0 0-.001.908m35.331 22.639a.525.525 0 0 0 0 .908l4.185 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.53.53 0 0 0-.526.001m-42.399 24.474a.524.524 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m3.531-2.039a.524.524 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m3.537-2.039a.525.525 0 0 0 .001.908l4.185 2.419a.524.524 0 1 0 .525-.908l-4.184-2.42a.53.53 0 0 0-.527.001m-10.599 6.117a.524.524 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-3.531 2.039a.524.524 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-7.069 4.084a.525.525 0 0 0 .001.909l4.185 2.419a.525.525 0 1 0 .525-.909l-4.185-2.419a.53.53 0 0 0-.526 0m24.73-14.279a.525.525 0 0 0 .001.908l4.185 2.419a.524.524 0 1 0 .525-.908l-4.184-2.419a.53.53 0 0 0-.527 0m-21.199 12.24a.525.525 0 0 0 .001.909l4.184 2.419a.525.525 0 0 0 .526-.909l-4.185-2.419a.53.53 0 0 0-.526 0m42.399-24.48a.525.525 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-49.461 28.558a.525.525 0 0 0 .001.909l4.185 2.419a.525.525 0 1 0 .525-.909l-4.185-2.419a.53.53 0 0 0-.526 0m52.992-30.597a.525.525 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-114.444-2.039a.52.52 0 0 0-.526-.001l-4.185 2.419a.525.525 0 0 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m107.375 6.117a.525.525 0 0 0 .001.908l4.185 2.419a.526.526 0 1 0 .525-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-3.531 2.039a.525.525 0 0 0 .001.908l4.185 2.419a.525.525 0 1 0 .525-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-10.6 6.123a.525.525 0 0 0 .001.908l4.185 2.42a.526.526 0 0 0 .525-.909l-4.184-2.419a.53.53 0 0 0-.527 0m3.538-2.039a.525.525 0 0 0 .001.909l4.185 2.419a.525.525 0 1 0 .525-.909l-4.185-2.419a.53.53 0 0 0-.526 0m3.531-2.039a.525.525 0 0 0 .001.909l4.185 2.419a.525.525 0 1 0 .525-.909l-4.185-2.419a.53.53 0 0 0-.526 0m17.662-10.201a.524.524 0 0 0 .001.908l4.184 2.419a.526.526 0 0 0 .526-.909l-4.185-2.419a.52.52 0 0 0-.526.001m-103.844 8.162a.53.53 0 0 0-.527 0l-4.184 2.419a.524.524 0 1 0 .525.909l4.185-2.419a.526.526 0 0 0 .001-.909m14.137 8.156a.52.52 0 0 0-.526 0l-4.185 2.419a.525.525 0 1 0 .525.908l4.185-2.419a.525.525 0 0 0 .001-.908m-7.069-4.078a.53.53 0 0 0-.526 0l-4.185 2.419a.525.525 0 0 0 .526.909l4.184-2.419a.525.525 0 0 0 .001-.909m3.531 2.039a.53.53 0 0 0-.526 0l-4.185 2.419a.525.525 0 0 0 .526.909l4.184-2.42a.524.524 0 0 0 .001-.908m-7.062-4.078a.53.53 0 0 0-.526 0l-4.185 2.419a.525.525 0 0 0 .526.909l4.184-2.419a.525.525 0 0 0 .001-.909m-14.13-8.162a.53.53 0 0 0-.527-.001l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m3.531 2.039a.53.53 0 0 0-.527-.001l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m3.531 2.045a.53.53 0 0 0-.527 0l-4.184 2.419a.524.524 0 1 0 .525.909l4.185-2.419a.526.526 0 0 0 .001-.909m28.261 16.312a.52.52 0 0 0-.526-.001l-4.185 2.419a.525.525 0 0 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m10.6 6.123a.53.53 0 0 0-.527 0l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.909m-3.531-2.039a.53.53 0 0 0-.527 0l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.909m7.062 4.078a.53.53 0 0 0-.527 0l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.909m-21.193-12.24a.53.53 0 0 0-.526-.001l-4.185 2.42a.525.525 0 1 0 .525.908l4.185-2.419a.525.525 0 0 0 .001-.908m20.02 16.698a.524.524 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0-.526-.909zm-16.489-14.659a.52.52 0 0 0-.526-.001l-4.185 2.419a.525.525 0 0 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m7.069 4.085a.53.53 0 0 0-.527-.001l-4.184 2.419a.525.525 0 1 0 .525.909l4.185-2.419a.525.525 0 0 0 .001-.908m9.419-66.759a.525.525 0 0 0 .001.909l4.184 2.419a.525.525 0 1 0 .526-.909l-4.185-2.419a.53.53 0 0 0-.526 0m12.76 33.368a.67.67 0 0 0-.675 0l-6.076 3.506a.68.68 0 0 1-.675-.001l-2.506-1.448a.675.675 0 0 1 0-1.169l5.619-3.247c.45-.26.45-.909.001-1.169l-1.359-.786a.68.68 0 0 0-.676 0l-9.667 5.58a.675.675 0 0 0 0 1.169l13.226 7.64c.209.12.466.121.675 0l2.023-1.165a.675.675 0 0 0 0-1.17l-3.285-1.895a.676.676 0 0 1 0-1.17l4.725-2.726c.45-.26.45-.91 0-1.169zm-22.799 5.202c-.45.26-.45.91 0 1.17l5.376 3.104c.616.355.334 1.299-.377 1.258l-13.061-.75a.7.7 0 0 0-.377.09l-1.603.927a.675.675 0 0 0 .001 1.169l13.227 7.64a.67.67 0 0 0 .675 0l1.985-1.144c.45-.26.45-.91 0-1.17l-5.381-3.107c-.616-.356-.334-1.299.376-1.259l13.088.74a.67.67 0 0 0 .376-.089l1.582-.915a.676.676 0 0 0 0-1.169l-13.228-7.64a.68.68 0 0 0-.675 0zm29.348-12.604a.675.675 0 0 1 0-1.169l2.64-1.524c.45-.26.45-.91 0-1.17l-1.398-.807a.68.68 0 0 0-.675 0l-11.356 6.559c-.45.26-.45.91 0 1.17l1.398.807c.209.12.466.12.675 0l3.99-2.304a.67.67 0 0 1 .675 0l11.153 6.442a.68.68 0 0 0 .676 0l2.026-1.171a.675.675 0 0 0 0-1.169z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.606,
    d: "m430.245 294.261-80.119 46.26L270 294.261 350.126 248z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M459.608 268.314c-1.108 0-2.161-.222-2.974-.702l-66.866-38.597c-.869-.499-1.33-1.22-1.33-2.014 0-.924.646-1.829 1.792-2.476l65.96-38.08c2.014-1.164 4.989-1.275 6.744-.258l66.866 38.597c.869.499 1.331 1.219 1.331 2.014 0 .923-.647 1.829-1.793 2.475l-65.96 38.08c-1.09.647-2.458.961-3.77.961m-2.457-1.589c1.423.831 4.046.702 5.709-.259l65.961-38.079c.794-.462 1.275-1.054 1.275-1.589 0-.536-.444-.906-.813-1.109l-66.866-38.597c-1.423-.832-4.046-.702-5.709.259l-65.961 38.079c-.794.462-1.275 1.053-1.275 1.589s.444.906.813 1.109z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__o)",
    d: "M531.13 205.289v8.267l-71.565 41.325L388 213.556v-8.267z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__p)",
    d: "M531.13 205.289v8.267l-71.565 41.325L388 213.556v-8.267z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__q)",
    d: "M459.565 246.605 388 205.289l71.565-41.315 71.565 41.315z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m459.565 245.64-70.723-40.838-.842.488 71.565 41.315 71.565-41.315-.842-.479z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m459.571 237.08-55.041-31.782 55.041-31.773 55.04 31.773z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__r)",
    d: "m459.569 237.08-55.041-31.782 55.041-31.773 55.04 31.773z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__s)",
    d: "m459.569 165.506 55.041 31.782v8.01l-55.041-31.782z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__t)",
    d: "m459.569 173.516-55.041 31.782v-8.01l55.041-31.782z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__u)",
    d: "m459.569 229.062-55.041-31.774 55.041-31.782 55.04 31.782z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m459.569 209.985-21.992-12.696 21.992-12.697 21.991 12.697z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m459.569 185.752 20.981 12.121 1.01-.584-21.991-12.697-21.992 12.697 1.01.584z",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__v)",
    d: "M459.569 229.062v8.018l55.041-31.782v-8.01z",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__w)",
    d: "M404.528 197.289v8.009l55.041 31.782v-8.018z",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m459.571 228.194-54.288-31.348-.753.443 55.041 31.773 55.04-31.773-.753-.443z",
    opacity: 0.8
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__x)",
    d: "M459.769 154.713v-37.061l-30.734-19.117zm-33.283-61.884 33.283 20.699V32l-33.283 60.83z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__y)",
    d: "M459.769 154.713v-37.061l-30.734-19.117zm-33.283-61.884 33.283 20.699V32l-33.283 60.83z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__z)",
    d: "m459.77 154.713 30.74-56.178-30.74 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__A)",
    d: "m459.77 154.713 30.74-56.178-30.74 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M315.26 175.22c-.701 0-1.367-.14-1.88-.443l-42.265-24.397c-.549-.315-.841-.771-.841-1.273 0-.584.409-1.156 1.133-1.565l41.692-24.069c1.273-.736 3.154-.806 4.263-.163l42.264 24.396c.549.315.841.771.841 1.273 0 .584-.409 1.156-1.133 1.565l-41.692 24.069c-.689.409-1.553.607-2.382.607m-1.553-1.004c.899.525 2.557.444 3.608-.164l41.692-24.069c.503-.292.806-.665.806-1.004s-.28-.572-.514-.701l-42.264-24.396c-.899-.526-2.558-.444-3.609.163l-41.692 24.07c-.502.292-.806.665-.806 1.004s.281.572.514.701z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__B)",
    d: "M360.469 135.384v5.225l-45.234 26.12L270 140.609v-5.225z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__C)",
    d: "M360.469 135.384v5.225l-45.234 26.12L270 140.609v-5.225z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__D)",
    d: "M315.235 161.499 270 135.384l45.235-26.115 45.234 26.115z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m315.235 160.888-44.703-25.812-.532.308 45.235 26.115 45.234-26.115-.532-.302z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m315.236 155.478-34.79-20.089 34.79-20.083 34.79 20.083z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__E)",
    d: "m315.233 155.478-34.79-20.088 34.79-20.083 34.79 20.083z",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__F)",
    d: "m315.233 110.238 34.79 20.089v5.062l-34.79-20.088z",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__G)",
    d: "m315.233 115.301-34.79 20.088v-5.062l34.79-20.089z",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__H)",
    d: "m315.233 150.41-34.79-20.083 34.79-20.089 34.79 20.089z",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m315.232 138.352-13.9-8.025 13.9-8.025 13.9 8.025z",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m315.232 123.035 13.262 7.662.638-.37-13.9-8.025-13.9 8.025.638.37z",
    opacity: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__I)",
    d: "M315.233 150.41v5.068l34.79-20.089v-5.062z",
    opacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__J)",
    d: "M280.443 130.327v5.063l34.79 20.088v-5.068z",
    opacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m315.236 149.861-34.314-19.814-.476.28 34.79 20.083 34.79-20.083-.476-.28z",
    opacity: 0.8
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__K)",
    d: "M315.361 77.564V54.138l-19.426-12.083 19.426 35.51zM294.324 38.45l21.037 13.083V0l-21.037 38.449z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__L)",
    d: "M315.361 77.564V54.138l-19.426-12.083 19.426 35.51zM294.324 38.45l21.037 13.083V0l-21.037 38.449z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__M)",
    d: "m315.362 77.564 19.431-35.509-19.431 12.083zm0-77.564v51.532l21.042-13.083z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__N)",
    d: "m315.362 77.564 19.431-35.509-19.431 12.083zm0-77.564v51.532l21.042-13.083z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M45.262 342.63c-.7 0-1.367-.14-1.88-.444L1.117 317.79c-.549-.315-.84-.771-.84-1.273 0-.584.408-1.156 1.132-1.565l41.692-24.069c1.273-.736 3.154-.806 4.263-.164l42.264 24.397c.55.315.841.77.841 1.273 0 .584-.409 1.156-1.133 1.565l-41.692 24.069c-.689.409-1.553.607-2.382.607m-1.553-1.004c.899.525 2.557.444 3.608-.164l41.692-24.069c.502-.292.806-.666.806-1.004 0-.339-.28-.573-.514-.701l-42.264-24.396c-.9-.526-2.558-.444-3.609.163L1.736 315.524c-.502.292-.806.666-.806 1.005s.28.572.514.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__O)",
    d: "M90.469 302.794v5.225l-45.234 26.12L0 308.019v-5.225z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__P)",
    d: "M90.469 302.794v5.225l-45.234 26.12L0 308.019v-5.225z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__Q)",
    d: "M45.234 328.909 0 302.794l45.234-26.115 45.235 26.115z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.234 328.298.532 302.486l-.532.308 45.234 26.115 45.235-26.115-.532-.302z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m45.237 322.888-34.79-20.089 34.79-20.083 34.79 20.083z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__R)",
    d: "M45.235 322.888 10.445 302.8l34.79-20.084 34.79 20.084z",
    opacity: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__S)",
    d: "m45.235 277.648 34.79 20.089v5.062l-34.79-20.088z",
    opacity: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__T)",
    d: "m45.235 282.711-34.79 20.088v-5.062l34.79-20.089z",
    opacity: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__U)",
    d: "m45.235 317.82-34.79-20.083 34.79-20.089 34.79 20.089z",
    opacity: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m45.234 305.762-13.9-8.025 13.9-8.026 13.9 8.026z",
    opacity: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m45.234 290.445 13.262 7.661.638-.369-13.9-8.026-13.9 8.026.638.369z",
    opacity: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__V)",
    d: "M45.235 317.82v5.068l34.79-20.089v-5.062z",
    opacity: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__W)",
    d: "M10.445 297.737v5.062l34.79 20.089v-5.068z",
    opacity: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m45.237 317.271-34.314-19.814-.476.28 34.79 20.083 34.79-20.083-.476-.28z",
    opacity: 0.8
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__X)",
    d: "M45.361 232.821v-23.426l-19.426-12.083zm-21.037-39.115 21.037 13.083v-51.532z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__Y)",
    d: "M45.361 232.821v-23.426l-19.426-12.083zm-21.037-39.115 21.037 13.083v-51.532z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__Z)",
    d: "m45.362 232.821 19.43-35.509-19.43 12.083zm0-77.564v51.532l21.042-13.083z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__aa)",
    d: "m45.362 232.821 19.43-35.509-19.43 12.083zm0-77.564v51.532l21.042-13.083z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M198.606 268.314c-1.108 0-2.161-.222-2.974-.702l-66.866-38.597c-.869-.499-1.33-1.22-1.33-2.014 0-.924.646-1.829 1.792-2.476l65.96-38.08c2.014-1.164 4.989-1.275 6.744-.258l66.866 38.597c.869.499 1.331 1.219 1.331 2.014 0 .923-.647 1.829-1.793 2.475l-65.96 38.08c-1.09.647-2.458.961-3.77.961m-2.457-1.589c1.423.831 4.046.702 5.709-.259l65.961-38.079c.795-.462 1.275-1.054 1.275-1.589 0-.536-.444-.906-.813-1.109l-66.866-38.597c-1.423-.832-4.046-.702-5.709.259l-65.961 38.079c-.794.462-1.275 1.053-1.275 1.589s.444.906.813 1.109z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ab)",
    d: "M270.13 205.289v8.267l-71.565 41.325L127 213.556v-8.267z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ac)",
    d: "M270.13 205.289v8.267l-71.565 41.325L127 213.556v-8.267z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ad)",
    d: "M198.565 246.605 127 205.289l71.565-41.315 71.565 41.315z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m198.565 245.64-70.723-40.838-.842.488 71.565 41.315 71.565-41.315-.842-.479z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m198.568 237.08-55.041-31.782 55.041-31.773 55.04 31.773z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ae)",
    d: "m198.564 237.08-55.041-31.782 55.041-31.773 55.04 31.773z",
    opacity: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__af)",
    d: "m198.564 165.506 55.041 31.782v8.01l-55.041-31.782z",
    opacity: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ag)",
    d: "m198.564 173.516-55.041 31.782v-8.01l55.041-31.782z",
    opacity: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ah)",
    d: "m198.564 229.062-55.041-31.774 55.041-31.782 55.04 31.782z",
    opacity: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m198.564 209.985-21.992-12.697 21.992-12.696 21.991 12.696z",
    opacity: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m198.564 185.752 20.981 12.121 1.01-.585-21.991-12.696-21.992 12.696 1.01.585z",
    opacity: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ai)",
    d: "M198.564 229.062v8.018l55.041-31.782v-8.01z",
    opacity: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__aj)",
    d: "M143.523 197.289v8.009l55.041 31.782v-8.018z",
    opacity: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m198.568 228.193-54.288-31.348-.753.443 55.041 31.774 55.04-31.774-.753-.443z",
    opacity: 0.8
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ak)",
    d: "M198.764 154.713v-37.061L168.03 98.535zm-33.283-61.884 33.283 20.699V32l-33.283 60.83z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__al)",
    d: "M198.764 154.713v-37.061L168.03 98.535zm-33.283-61.884 33.283 20.699V32l-33.283 60.83z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__am)",
    d: "m198.765 154.713 30.74-56.178-30.74 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__an)",
    d: "m198.765 154.713 30.74-56.178-30.74 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M176.929 461.111c-1.109 0-2.162-.222-2.975-.702l-66.866-38.597c-.868-.499-1.33-1.22-1.33-2.014 0-.924.646-1.83 1.792-2.476l65.961-38.08c2.014-1.164 4.988-1.275 6.744-.259l66.866 38.597c.868.499 1.33 1.22 1.33 2.014 0 .924-.647 1.83-1.792 2.476l-65.961 38.08c-1.09.647-2.457.961-3.769.961m-2.458-1.589c1.423.831 4.047.702 5.71-.259l65.96-38.08c.795-.462 1.275-1.053 1.275-1.589 0-.535-.443-.905-.813-1.108l-66.866-38.597c-1.422-.832-4.046-.702-5.709.258l-65.961 38.08c-.794.462-1.275 1.053-1.275 1.589s.444.905.813 1.109z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ao)",
    d: "M248.452 398.086v8.267l-71.565 41.324-71.565-41.324v-8.267z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ap)",
    d: "M248.452 398.086v8.267l-71.565 41.324-71.565-41.324v-8.267z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__aq)",
    d: "m176.887 439.402-71.565-41.316 71.565-41.316 71.565 41.316z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m176.887 438.436-70.723-40.837-.842.487 71.565 41.316 71.565-41.316-.841-.478z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m176.89 429.877-55.04-31.782 55.04-31.773 55.041 31.773z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ar)",
    d: "m176.886 429.877-55.04-31.782 55.04-31.773 55.041 31.773z",
    opacity: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__as)",
    d: "m176.887 358.303 55.04 31.782v8.01l-55.04-31.782z",
    opacity: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__at)",
    d: "m176.886 366.313-55.04 31.782v-8.01l55.04-31.782z",
    opacity: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__au)",
    d: "m176.886 421.858-55.04-31.773 55.04-31.782 55.041 31.782z",
    opacity: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m176.886 402.782-21.991-12.697 21.991-12.697 21.991 12.697z",
    opacity: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m176.886 378.549 20.981 12.121 1.01-.585-21.991-12.697-21.991 12.697 1.01.585z",
    opacity: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__av)",
    d: "M176.887 421.858v8.019l55.04-31.782v-8.01z",
    opacity: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__aw)",
    d: "M121.846 390.085v8.01l55.04 31.782v-8.018z",
    opacity: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m176.89 420.99-54.287-31.348-.753.443 55.04 31.773 55.041-31.773-.753-.443z",
    opacity: 0.8
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ax)",
    d: "M177.086 347.51v-37.061l-30.733-19.117zm-33.282-61.884 33.282 20.699v-81.528z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__ay)",
    d: "M177.086 347.51v-37.061l-30.733-19.117zm-33.282-61.884 33.282 20.699v-81.528z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__az)",
    d: "m177.087 347.51 30.741-56.178-30.741 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nftDevelopment_svg__aA)",
    d: "m177.087 347.51 30.741-56.178-30.741 19.117zm0-122.713v81.528l33.289-20.699z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__a",
    x1: 269.995,
    x2: 430.249,
    y1: 316.372,
    y2: 316.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__b",
    x1: 238.057,
    x2: 335.134,
    y1: 308.381,
    y2: 365.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477EC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__c",
    x1: 270.836,
    x2: 305.992,
    y1: 367.208,
    y2: 307.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A6B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__d",
    x1: 282.503,
    x2: 476.717,
    y1: 344.848,
    y2: 355.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5192A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#35568A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#1F2773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#110B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C005F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__e",
    x1: 350.961,
    x2: 386.118,
    y1: 367.208,
    y2: 307.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__f",
    x1: 350.961,
    x2: 386.118,
    y1: 367.208,
    y2: 307.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__g",
    x1: 269.998,
    x2: 430.247,
    y1: 294.259,
    y2: 294.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#4073A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__h",
    x1: 269.995,
    x2: 430.249,
    y1: 294.254,
    y2: 294.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__i",
    x1: 330.914,
    x2: 360.944,
    y1: 260.991,
    y2: 313.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#7BDEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#2364A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__j",
    x1: 290.061,
    x2: 410.182,
    y1: 294.256,
    y2: 294.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__k",
    x1: 243.636,
    x2: 333.191,
    y1: 281.606,
    y2: 334.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477EC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__l",
    x1: 270.836,
    x2: 294.096,
    y1: 333.355,
    y2: 282.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A6B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__m",
    x1: 346.77,
    x2: 430.878,
    y1: 345.272,
    y2: 297.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5192A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#35568A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#1F2773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#110B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C005F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__n",
    x1: 350.961,
    x2: 374.223,
    y1: 333.355,
    y2: 282.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__o",
    x1: 352.619,
    x2: 536.025,
    y1: 230.083,
    y2: 230.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__p",
    x1: 389.494,
    x2: 402.563,
    y1: 241.94,
    y2: 187.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__q",
    x1: 459.565,
    x2: 459.565,
    y1: 163.974,
    y2: 246.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__r",
    x1: 404.525,
    x2: 514.612,
    y1: 205.298,
    y2: 205.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__s",
    x1: 459.568,
    x2: 514.611,
    y1: 185.4,
    y2: 185.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__t",
    x1: 404.527,
    x2: 459.57,
    y1: 185.4,
    y2: 185.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__u",
    x1: 404.525,
    x2: 514.612,
    y1: 197.28,
    y2: 197.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__v",
    x1: 459.568,
    x2: 514.611,
    y1: 217.182,
    y2: 217.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__w",
    x1: 404.527,
    x2: 459.57,
    y1: 217.182,
    y2: 217.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__x",
    x1: 441.152,
    x2: 456.101,
    y1: 50.376,
    y2: 141.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__y",
    x1: 446.431,
    x2: 484.256,
    y1: 128.017,
    y2: 90.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__z",
    x1: 465.403,
    x2: 477.301,
    y1: 157.975,
    y2: 54.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__A",
    x1: 490.511,
    x2: 411.859,
    y1: 155.273,
    y2: 86.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__B",
    x1: 247.636,
    x2: 363.563,
    y1: 151.055,
    y2: 151.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__C",
    x1: 270.944,
    x2: 279.205,
    y1: 158.55,
    y2: 123.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__D",
    x1: 315.235,
    x2: 315.235,
    y1: 109.269,
    y2: 161.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__E",
    x1: 280.441,
    x2: 350.024,
    y1: 135.39,
    y2: 135.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__F",
    x1: 315.232,
    x2: 350.024,
    y1: 122.812,
    y2: 122.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__G",
    x1: 280.442,
    x2: 315.234,
    y1: 122.812,
    y2: 122.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__H",
    x1: 280.441,
    x2: 350.024,
    y1: 130.321,
    y2: 130.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__I",
    x1: 315.232,
    x2: 350.024,
    y1: 142.901,
    y2: 142.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__J",
    x1: 280.442,
    x2: 315.234,
    y1: 142.901,
    y2: 142.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__K",
    x1: 303.594,
    x2: 313.043,
    y1: 11.615,
    y2: 69.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__L",
    x1: 306.931,
    x2: 330.839,
    y1: 60.69,
    y2: 36.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__M",
    x1: 318.923,
    x2: 326.444,
    y1: 79.626,
    y2: 14.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__N",
    x1: 334.793,
    x2: 285.079,
    y1: 77.918,
    y2: 34.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__O",
    x1: -22.364,
    x2: 93.563,
    y1: 318.465,
    y2: 318.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__P",
    x1: 0.944,
    x2: 9.205,
    y1: 325.96,
    y2: 291.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__Q",
    x1: 45.234,
    x2: 45.234,
    y1: 276.679,
    y2: 328.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__R",
    x1: 10.443,
    x2: 80.026,
    y1: 302.8,
    y2: 302.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__S",
    x1: 45.234,
    x2: 80.026,
    y1: 290.222,
    y2: 290.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__T",
    x1: 10.444,
    x2: 45.236,
    y1: 290.222,
    y2: 290.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__U",
    x1: 10.443,
    x2: 80.026,
    y1: 297.731,
    y2: 297.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__V",
    x1: 45.234,
    x2: 80.026,
    y1: 310.311,
    y2: 310.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__W",
    x1: 10.444,
    x2: 45.236,
    y1: 310.311,
    y2: 310.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__X",
    x1: 33.594,
    x2: 43.043,
    y1: 166.872,
    y2: 224.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__Y",
    x1: 36.931,
    x2: 60.839,
    y1: 215.947,
    y2: 192.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__Z",
    x1: 48.923,
    x2: 56.444,
    y1: 234.883,
    y2: 169.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__aa",
    x1: 64.793,
    x2: 15.079,
    y1: 233.175,
    y2: 189.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ab",
    x1: 91.619,
    x2: 275.025,
    y1: 230.083,
    y2: 230.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ac",
    x1: 128.494,
    x2: 141.563,
    y1: 241.94,
    y2: 187.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ad",
    x1: 198.565,
    x2: 198.565,
    y1: 163.974,
    y2: 246.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ae",
    x1: 143.52,
    x2: 253.607,
    y1: 205.298,
    y2: 205.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__af",
    x1: 198.563,
    x2: 253.606,
    y1: 185.4,
    y2: 185.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ag",
    x1: 143.522,
    x2: 198.565,
    y1: 185.4,
    y2: 185.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ah",
    x1: 143.52,
    x2: 253.607,
    y1: 197.28,
    y2: 197.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ai",
    x1: 198.563,
    x2: 253.606,
    y1: 217.182,
    y2: 217.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__aj",
    x1: 143.522,
    x2: 198.565,
    y1: 217.182,
    y2: 217.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ak",
    x1: 180.147,
    x2: 195.096,
    y1: 50.376,
    y2: 141.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__al",
    x1: 185.426,
    x2: 223.252,
    y1: 128.017,
    y2: 90.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__am",
    x1: 204.398,
    x2: 216.296,
    y1: 157.975,
    y2: 54.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__an",
    x1: 229.506,
    x2: 150.854,
    y1: 155.273,
    y2: 86.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ao",
    x1: 69.941,
    x2: 253.347,
    y1: 422.879,
    y2: 422.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ap",
    x1: 106.816,
    x2: 119.886,
    y1: 434.737,
    y2: 380.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__aq",
    x1: 176.887,
    x2: 176.887,
    y1: 356.77,
    y2: 439.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ar",
    x1: 121.843,
    x2: 231.929,
    y1: 398.095,
    y2: 398.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__as",
    x1: 176.885,
    x2: 231.928,
    y1: 378.196,
    y2: 378.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__at",
    x1: 121.844,
    x2: 176.887,
    y1: 378.196,
    y2: 378.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__au",
    x1: 121.843,
    x2: 231.929,
    y1: 390.076,
    y2: 390.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__av",
    x1: 176.885,
    x2: 231.928,
    y1: 409.978,
    y2: 409.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__aw",
    x1: 121.844,
    x2: 176.887,
    y1: 409.979,
    y2: 409.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ax",
    x1: 158.469,
    x2: 173.418,
    y1: 243.173,
    y2: 334.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__ay",
    x1: 163.748,
    x2: 201.574,
    y1: 320.814,
    y2: 283.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__az",
    x1: 182.72,
    x2: 194.619,
    y1: 350.772,
    y2: 247.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftDevelopment_svg__aA",
    x1: 207.829,
    x2: 129.176,
    y1: 348.07,
    y2: 279.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })))));
};
export default SvgNftDevelopment;